export default __webpack_public_path__ + "static/media/file.9f76fe1b.svg";